export interface ApiResponse {
    text: string;
    authenticated: boolean;
    claims: Array<{
        type: string;
        value: string;
    }>;
}

export interface AppState {
    isDarkTheme: boolean;
    isLoading: boolean;
    error: Error | null;
    initialized: boolean;
    userName: string;
    language: StaffLanguage;
    userMediaList: UserMedia[];
    setIsDarkTheme: (isDark: boolean) => void;
    setError: (error: Error | null) => void;
    setLoading: (isLoading: boolean) => void;
    setUserName: (userName: string) => void;
    setLanguage: (language: StaffLanguage) => void;
    fetchMediaLists: () => Promise<void>;
    selectedMediaId: number | null;
    setSelectedMediaId: (id: number | null) => void;
}

export enum StaffLanguage {
    Japanese = 'Japanese',
    English = 'English',
    Korean = 'Korean',
    Italian = 'Italian',
    Spanish = 'Spanish',
    Portuguese = 'Portuguese',
    French = 'French',
    German = 'German',
    Hebrew = 'Hebrew',
    Hungarian = 'Hungarian',
}

export interface UserMedia {
    id: number;
    title: {
        english: string | null;
        romaji: string | null;
    };
    coverImage: {
        medium: string;
        large: string;
    };
    bannerImage: string | null;
    description: string | null;
    averageScore: number | null;
    popularity: number | null;
    episodes: number | null;
    genres: Array<string>;

    userStatus: string;
    userScore: number | null;
    userProgress: number | null;
    userRepeat: number | null;

    characters: Character[];
}

export interface Character {
    id: number;
    name: string;
    imageUrl: string | null;
    role: string;
    voiceActor: VoiceActor | null;
}

export interface VoiceActor {
    id: number;
    name: string | null;
    imageUrl: string | null;
}